// iconMap.ts

import {
  ApartmentOutlined,
  AppstoreOutlined,
  ControlOutlined,
  CrownOutlined,
  DashboardOutlined,
  HomeOutlined,
  MenuOutlined,
  ProfileOutlined,
  SafetyOutlined,
  SettingOutlined,
  TableOutlined,
  TeamOutlined,
  ToolOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React from 'react';

export const MENU_ICONS = {
  crown: { label: '皇冠', icon: <CrownOutlined /> },
  table: { label: '表格', icon: <TableOutlined /> },
  user: { label: '用户', icon: <UserOutlined /> },
  setting: { label: '设置', icon: <SettingOutlined /> },

  // 一些常用的
  home: { label: '首页', icon: <HomeOutlined /> },
  dashboard: { label: '仪表盘', icon: <DashboardOutlined /> },
  appstore: { label: '应用', icon: <AppstoreOutlined /> },
  profile: { label: '资料', icon: <ProfileOutlined /> },
  menu: { label: '菜单', icon: <MenuOutlined /> },
  list: { label: '列表', icon: <UnorderedListOutlined /> },
  safety: { label: '安全', icon: <SafetyOutlined /> },
  team: { label: '团队', icon: <TeamOutlined /> },
  tool: { label: '工具', icon: <ToolOutlined /> },
  control: { label: '控制', icon: <ControlOutlined /> },
  apartment: { label: '组织', icon: <ApartmentOutlined /> },
} as const;

export type MenuIconKey = keyof typeof MENU_ICONS;

export function renderMenuIcon(key?: string) {
  if (!key) return null;
  return (MENU_ICONS as any)[key]?.icon ?? null;
}
